import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { Modal, Button } from 'antd';

const ForgetPassword = props => {
  //点击“取消按钮”隐藏对话框
  const handleCancel = changed => {
    props.onCancel(changed);
  };

  return (
    <div className="group-modal">
      <Modal
        title="忘记密码"
        visible={props.visible}
        width="600px"
        height={'60%'}
        onCancel={() => handleCancel(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => handleCancel(false)}
            type="default"
            className="btn-cancel"
          >
            知道了
          </Button>,
        ]}
        className="forget-password"
      >
        <div className="forget-password-modal">
          {/* 弹出框 */}
          <div>
            <p>账户或密码忘记，请联系九峰医疗客服。</p>
            <p>
              客服电话<span>400-886-9793</span>
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};
ForgetPassword.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.object,
};
export default withRouter(ForgetPassword);
